import React from 'react'
import PropTypes from 'prop-types'
import { compose, find, propEq, prop } from 'ramda'
import { isUndefined } from 'utils/types'
import { Paragraph } from 'components/patterns'
import { StyledReadOnlyView } from './ReadOnlyView.style'

const ReadOnlyView = ({ label, value, options }) => {
  const getTextValue = () => {
    if (isUndefined(options)) return value
    return compose(prop('text'), find(propEq('value', value)))(options)
  }

  return (
    <StyledReadOnlyView>
      <Paragraph small>{label}</Paragraph>
      <Paragraph bold>:&nbsp; {getTextValue()}</Paragraph>
    </StyledReadOnlyView>
  )
}

ReadOnlyView.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),
  options: PropTypes.array,
}

export default ReadOnlyView
